"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterCompiler = void 0;
const core_types_1 = require("@dqm/core-types");
const Expression_1 = require("./Expression");
class FilterCompiler {
    constructor(generator) {
        this.generator = generator;
    }
    compile(source) {
        if ((0, Expression_1.isCompositeExpression)(source)) {
            return this.generator.generateCompositeFilter(source, this);
        }
        if ((0, Expression_1.isComparisonExpression)(source)) {
            return this.generator.generateComparisonFilter(source);
        }
        throw new core_types_1.ArgumentError();
    }
}
exports.FilterCompiler = FilterCompiler;
//# sourceMappingURL=FilterCompiler.js.map